var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-content" },
    [
      !_vm.loading
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-6" }, [
              _c("div", { staticClass: "card" }, [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "card-body" },
                  [
                    _c("SelectRunner", {
                      ref: "selectedRunner",
                      attrs: {
                        runners: _vm.runners,
                        useBackPacks: true,
                        runnerOrders: _vm.sortedOrders,
                        backPacks: _vm.backPacks,
                        updateSelectedRunner: (id) =>
                          (this.selectedRunner = id),
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6" }, [
              _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "card-body" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-info btn-sm",
                      on: { click: _vm.getRecords },
                    },
                    [_vm._v("Обновить заявки")]
                  ),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading
        ? _c(
            "div",
            { attrs: { id: "print_orders" } },
            _vm._l(_vm.displayListOfOrders, function (title, index) {
              return _vm.sortedOrders &&
                _vm.sortedOrders[index] &&
                _vm.sortedOrders[index].length > 0
                ? _c(
                    "div",
                    { class: { no_print: !_vm.showRunnerOrders[index] } },
                    [
                      _c("div", { staticClass: "card" }, [
                        _c("div", { staticClass: "card-header" }, [
                          _c("h5", [
                            _vm._v(
                              "\n            " +
                                _vm._s(title) +
                                " (" +
                                _vm._s(_vm.sortedOrders[index].length) +
                                ")\n            "
                            ),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-default pull-right no_print",
                                on: {
                                  click: function ($event) {
                                    _vm.showRunnerOrders[index] =
                                      !_vm.showRunnerOrders[index]
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.showRunnerOrders[index]
                                        ? "Скрыть"
                                        : "Показать"
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm.showRunnerOrders[index]
                          ? _c(
                              "div",
                              { staticClass: "card-body" },
                              [
                                _c("OrderList", {
                                  attrs: {
                                    storeStatusByOrders:
                                      _vm.storeStatusByOrders,
                                    orders: _vm.getSortedOrders(
                                      _vm.sortedOrders[index]
                                    ),
                                    selectedRunner: _vm.selectedRunner,
                                    runnerId: index == 0 ? false : index,
                                    runnerName: _vm.runners[_vm.selectedRunner],
                                    updateRootOrders: _vm.updateRootOrders,
                                    payMethod: "cod_paid",
                                    senders: _vm.senders,
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showRunnerOrders[index] && index > 0
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "card-footer text-right bg-custom-green",
                              },
                              [
                                _c("LoadingButton", {
                                  attrs: {
                                    title: "сгенерировать файл",
                                    className: "btn btn-outline-success btn-xs",
                                    onClick: () => _vm.fileGenerate(index),
                                    loading: _vm.loadingSenderBtns[index],
                                    color: _vm.$constants.SUCCESS_COLOR,
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]),
                    ]
                  )
                : _vm._e()
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      false
        ? _c("div", { staticClass: "card" }, [
            !_vm.loading
              ? _c("div", { staticClass: "card-header" }, [
                  _c("h5", [_vm._v("Отправители")]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card-body" },
              [
                _vm.loading
                  ? [
                      _c("pulse-loader", {
                        staticClass: "text-center",
                        attrs: { loading: true, color: _vm.loadingColor },
                      }),
                    ]
                  : [
                      _c(
                        "table",
                        { staticClass: "table table-hover table-sm" },
                        [
                          _vm._m(1),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            _vm._l(_vm.senders, function (sender) {
                              return _c("tr", { key: sender.id }, [
                                _c("td", [_vm._v(_vm._s(sender.order_num))]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(sender.name) +
                                      "(" +
                                      _vm._s(sender.id) +
                                      "), " +
                                      _vm._s(sender.phone)
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      sender.sum_limit.toLocaleString("ru-RU")
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.sendersOrders[
                                        sender.id
                                      ].limits.used.toLocaleString("ru-RU")
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      (
                                        sender.sum_limit -
                                        _vm.sendersOrders[sender.id].limits.used
                                      ).toLocaleString("ru-RU")
                                    )
                                  ),
                                ]),
                              ])
                            }),
                            0
                          ),
                        ]
                      ),
                    ],
              ],
              2
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      false && !_vm.loading
        ? _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-header" }, [
              _c("h5", { staticClass: "pull-left" }, [
                _vm._v("Заявки (наложенный платеж)"),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-info btn-xs pull-right",
                  on: { click: _vm.getRecords },
                },
                [_vm._v("Обновить заявки")]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card-body" }, [
              _c(
                "div",
                [
                  _c("CodOrdersList", {
                    ref: "orders",
                    attrs: { orders: _vm.orders },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "text-right" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-xs btn-success",
                    attrs: { type: "button" },
                    on: { click: _vm.appointOrders },
                  },
                  [_vm._v("Распределить выбранные заявки")]
                ),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.senders, function (sender) {
        return false &&
          _vm.sendersOrders[sender.id] &&
          _vm.sendersOrders[sender.id].orders.length &&
          _vm.getSenderOrders(sender.id, true)
          ? _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card-header" }, [
                _c("h5", [_vm._v(_vm._s(sender.name))]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card-body" },
                [
                  _c("CodOrdersList", {
                    ref: `orders_${sender.id}`,
                    refInFor: true,
                    attrs: {
                      appointed: true,
                      orders: _vm.getSenderOrders(sender.id),
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card-footer text-right" },
                [
                  _c("LoadingButton", {
                    attrs: {
                      title: "отметить отправленными",
                      className: "btn btn-outline-primary btn-xs",
                      onClick: () => _vm.updateOrders(sender.id, "sendOrders"),
                      loading: _vm.loadingSenderBtns[sender.id],
                      color: _vm.$constants.PRIMARY_COLOR,
                    },
                  }),
                  _vm._v(" "),
                  _c("LoadingButton", {
                    attrs: {
                      title: "сгенерировать файл",
                      className: "btn btn-outline-success btn-xs",
                      onClick: () => _vm.fileGenerate(sender.id),
                      loading: _vm.loadingSenderBtns[sender.id],
                      color: _vm.$constants.SUCCESS_COLOR,
                    },
                  }),
                ],
                1
              ),
            ])
          : _vm._e()
      }),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h6", [_vm._v("Курьеры из Вашей группы")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Данные")]),
        _vm._v(" "),
        _c("th", [_vm._v("Лимит")]),
        _vm._v(" "),
        _c("th", [_vm._v("Использован")]),
        _vm._v(" "),
        _c("th", [_vm._v("Доступен")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }